export function roundToDecimalPlace(num: number, decimalPlaces: number): number {
  const factor: number = Math.pow(10, decimalPlaces);
  return Math.round(num * factor) / factor;
}
